class KuleanaAgeGate {
  constructor(element) {
    this.element = element;
    this.dialog = element.querySelector('.age-gate__dialog');
    this.confirmButton = element.querySelector('[data-age-gate-confirm]');
    this.storageKey = element.dataset.storageKey || 'kuleana-age-verified';
    this.durationDays = Number(element.dataset.durationDays || 30);
    this.previewMode = element.dataset.preview === 'true';
    this.previouslyFocusedElement = null;

    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  init() {
    if (!this.previewMode && this.isVerified()) {
      this.element.remove();
      return;
    }

    this.confirmButton?.addEventListener('click', this.handleConfirm);
    document.addEventListener('keydown', this.handleKeydown);
    this.open();
  }

  isVerified() {
    try {
      const storedValue = window.localStorage.getItem(this.storageKey);
      if (!storedValue) return false;

      const record = JSON.parse(storedValue);

      if (!record?.expiresAt || Date.now() >= record.expiresAt) {
        window.localStorage.removeItem(this.storageKey);
        return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  saveVerification() {
    if (this.previewMode) return;

    const durationMilliseconds =
      Math.max(this.durationDays, 1) * 24 * 60 * 60 * 1000;

    try {
      window.localStorage.setItem(
        this.storageKey,
        JSON.stringify({
          verified: true,
          expiresAt: Date.now() + durationMilliseconds
        })
      );
    } catch (error) {
      /* Continue closing even if storage is unavailable. */
    }
  }

  open() {
    this.previouslyFocusedElement = document.activeElement;
    this.element.hidden = false;
    document.documentElement.classList.add('age-gate-is-open');

    requestAnimationFrame(() => {
      this.element.dataset.state = 'open';
      this.dialog?.focus({ preventScroll: true });
    });
  }

  close() {
    this.element.dataset.state = 'closing';
    document.documentElement.classList.remove('age-gate-is-open');
    document.removeEventListener('keydown', this.handleKeydown);
    this.confirmButton?.removeEventListener('click', this.handleConfirm);

    window.setTimeout(() => {
      this.element.hidden = true;
      this.element.dataset.state = 'closed';
      this.previouslyFocusedElement?.focus?.({ preventScroll: true });
    }, 280);
  }

  handleConfirm() {
    this.saveVerification();
    this.close();
  }

  handleKeydown(event) {
    if (event.key !== 'Tab') return;

    const focusableElements = Array.from(
      this.dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((item) => !item.hasAttribute('hidden'));

    if (!focusableElements.length) {
      event.preventDefault();
      this.dialog.focus();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-age-gate]').forEach((element) => {
    new KuleanaAgeGate(element).init();
  });
});